import StripeForm from './StripeForm';

export default StripeForm;
